import { CTAProps } from '@/components/CTA/CTA';
import { CTABlock } from '@/components/blocks/CTABlock/CTABlock';
import { KPIContentProps } from '@/components/blocks/KPIContent/KPIContent';
import { Typography } from '@eventbrite/marmalade';
import classNames from 'classnames';
import React from 'react';
import styles from './SingleKPI.module.scss';

export interface SingleKPIProps {
  kpi: KPIContentProps;
  ctas?: CTAProps[];
  caption?: string;
  className?: string;
}

export const SingleKPI: React.FC<SingleKPIProps> = ({ kpi, ctas, caption, className }) => {
  const styleClassNames = classNames(styles.single_kpi_container, className);
  return (
    <div className={styleClassNames}>
      <div className={styles.kpi_content}>
        {kpi.kpiCaption && <Typography className={styles.kpi_caption}>{kpi.kpiCaption}</Typography>}
        {kpi.kpiMetric && <Typography className={styles.kpi_metric}>{kpi.kpiMetric}</Typography>}
        {kpi.kpiLabel && <Typography className={styles.kpi_label}>{kpi.kpiLabel}</Typography>}
      </div>
      {ctas && <CTABlock ctas={ctas} caption={caption} />}
    </div>
  );
};
